// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__EXz83","subheader":"ReorderModal_subheader__3B5ib","listWrap":"ReorderModal_listWrap__1dX8F"};